// extracted by mini-css-extract-plugin
module.exports = {"InformationText":"InformationText_InformationText__8ciV4","InformationText_text":"InformationText_InformationText_text__8yYmD"};